import { ChainId } from '../../sdk/chainId'
import { getMulticallAddress } from '../../config/chainParams'
import { CHAINS } from '../../config/chains/index'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]?: string } = {}

for (const chainId of Object.keys(CHAINS).map((k) => Number(k) as ChainId)) {
  const chain = CHAINS[chainId]
  if (chain.configured) {
    MULTICALL_NETWORKS[chainId] = getMulticallAddress(chainId)
  }
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
